import { ITask } from "./types";

// Datos mock para testing cuando la API falla
export const mockTasksForProject136: ITask[] = [
  {
    id: "task-1",
    title: "Implementar autenticación OAuth",
    description: "Configurar el sistema de autenticación con OAuth 2.0",
    state: "en progreso",
    projectId: "136",
    sectionId: "70", // Backlog
    startDate: "2025-01-10",
    endDate: "2025-01-15",
    createdAt: "2025-01-08T10:00:00Z",
    parentTaskId: ""
  },
  {
    id: "task-2",
    title: "Diseñar interfaz de usuario",
    description: "Crear mockups y prototipos de la interfaz",
    state: "completada",
    projectId: "136",
    sectionId: "104", // On Going
    startDate: "2025-01-05",
    endDate: "2025-01-10",
    createdAt: "2025-01-05T09:00:00Z",
    parentTaskId: ""
  },
  {
    id: "task-3",
    title: "Configurar base de datos",
    description: "Configurar PostgreSQL y migraciones",
    state: "pendiente",
    projectId: "136",
    sectionId: "70", // Backlog
    startDate: "2025-01-15",
    endDate: "2025-01-20",
    createdAt: "2025-01-08T11:00:00Z",
    parentTaskId: ""
  },
  {
    id: "task-4",
    title: "Testing de integración",
    description: "Escribir y ejecutar tests de integración",
    state: "en progreso",
    projectId: "136",
    sectionId: "207", // QA
    startDate: "2025-01-12",
    endDate: "2025-01-18",
    createdAt: "2025-01-08T12:00:00Z",
    parentTaskId: ""
  },
  {
    id: "task-5",
    title: "Documentación técnica",
    description: "Crear documentación para desarrolladores",
    state: "pendiente",
    projectId: "136",
    sectionId: "70", // Backlog
    createdAt: "2025-01-08T13:00:00Z",
    parentTaskId: ""
  }
];

export const getMockTasksResponse = () => ({
  success: true,
  message: "Mock tasks loaded successfully",
  data: mockTasksForProject136
});